export const supportedEvmNetworkKeys = [
    "bnb",
    "eth",
    "base",
    "polygon",
];
const SAFE_CONTRACTS = {
    'eth': {
        singleton: "0x41675C099F32341bf84BFc5382aF534df5C7461a", //safe.sol
        singletonL2: "0x29fcB43b46531BcA003ddC8FCB67FFE91900C762", //safe_l2.sol
        proxyFactory: "0x4e1DCf7AD4e460CfD30791CCC4F9c8a4f820ec67", //safe_proxy_factory.sol
        multiSend: "0x38869bf66a61cF6bDB996A6aE40D5853Fd43B526", //multi_send.sol
        multiSendCallOnly: "0x9641d764fc13c8B624c04430C7356C1C7C8102e2", //multi_send_call_only.sol
        fallbackHandler: "0xfd0732Dc9E303f09fCEf3a7388Ad10A83459Ec99", //compatibility_fallback_handler.sol
    },
    'bnb': {
        singleton: "0x41675C099F32341bf84BFc5382aF534df5C7461a", //safe.sol
        singletonL2: "0x29fcB43b46531BcA003ddC8FCB67FFE91900C762", //safe_l2.sol
        proxyFactory: "0x4e1DCf7AD4e460CfD30791CCC4F9c8a4f820ec67", //safe_proxy_factory.sol
        multiSend: "0x38869bf66a61cF6bDB996A6aE40D5853Fd43B526", //multi_send.sol
        multiSendCallOnly: "0x9641d764fc13c8B624c04430C7356C1C7C8102e2", //multi_send_call_only.sol
        fallbackHandler: "0xfd0732Dc9E303f09fCEf3a7388Ad10A83459Ec99", //compatibility_fallback_handler.sol
    },
};
/**
 * Supported EVM networks for escrow deployment and deposit verification.
 *
 * Notes:
 * - `bnb-testnet` uses the official BNB Chain testnet RPC and faucet-issued
 *   USDC/USDT contracts.
 */
export const SUPPORTED_EVM_NETWORKS = {
    "bnb": {
        key: "bnb",
        label: "BNB",
        helper: "Mainnet",
        networkInfo: {
            id: 56,
            rpc: "https://bnb-mainnet.g.alchemy.com/v2/VvEiZureWG_Ux6ICdWQrU",
            name: "BNB Smart Chain",
            symbol: "BNB",
            decimals: 18,
            explorerUrl: "https://bscscan.com",
            isTestnet: false,
        },
        rewardToken: {
            usdt: {
                address: "0x55d398326f99059ff775485246999027b3197955",
                decimal: 18,
            },
            usdc: {
                address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
                decimal: 18,
            },
        },
        contracts: {
            safe: SAFE_CONTRACTS.bnb,
        },
    },
    "eth": {
        key: "eth",
        label: "Ethereum",
        helper: "Mainnet",
        networkInfo: {
            id: 1,
            rpc: "https://eth-mainnet.g.alchemy.com/v2/VvEiZureWG_Ux6ICdWQrU",
            name: "Ethereum",
            symbol: "ETH",
            decimals: 18,
            explorerUrl: "https://etherscan.io/",
            isTestnet: false,
        },
        rewardToken: {
            // ETH Chain stable-coins.
            usdt: {
                address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
                decimal: 6,
            },
            usdc: {
                address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
                decimal: 6,
            },
        },
        contracts: {
            safe: SAFE_CONTRACTS.eth,
        },
    },
    "base": {
        key: "base",
        label: "Base",
        helper: "Mainnet",
        networkInfo: {
            id: 8453,
            rpc: "https://base-mainnet.g.alchemy.com/v2/VvEiZureWG_Ux6ICdWQrU",
            name: "Base Smart Chain",
            symbol: "ETH",
            decimals: 18,
            explorerUrl: "https://basescan.org",
            isTestnet: false,
        },
        rewardToken: {
            usdt: {
                address: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
                decimal: 6,
            },
            usdc: {
                address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
                decimal: 6,
            },
        },
        contracts: {
            safe: SAFE_CONTRACTS.eth,
        },
    },
    "polygon": {
        key: "polygon",
        label: "Polygon",
        helper: "Mainnet",
        networkInfo: {
            id: 137,
            rpc: "https://polygon-mainnet.g.alchemy.com/v2/VvEiZureWG_Ux6ICdWQrU",
            name: "Polygon Mainnet",
            symbol: "POL",
            decimals: 18,
            explorerUrl: "https://polygonscan.com",
            isTestnet: false,
        },
        rewardToken: {
            usdt: {
                address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
                decimal: 6,
            },
            usdc: {
                address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
                decimal: 6,
            },
        },
        contracts: {
            safe: SAFE_CONTRACTS.bnb,
        },
    },
};
export const DEFAULT_SUPPORTED_EVM_NETWORK_KEY = "bnb";
export const SUPPORTED_EVM_NETWORK_OPTIONS = supportedEvmNetworkKeys.map((key) => ({
    key,
    label: SUPPORTED_EVM_NETWORKS[key].label,
    helper: SUPPORTED_EVM_NETWORKS[key].helper,
}));
export function isSupportedEvmNetworkKey(value) {
    return Boolean(value &&
        Object.prototype.hasOwnProperty.call(SUPPORTED_EVM_NETWORKS, value));
}
export function getSupportedEvmNetworkConfig(value) {
    if (!isSupportedEvmNetworkKey(value)) {
        return undefined;
    }
    return SUPPORTED_EVM_NETWORKS[value];
}
//-----------------
export const ABI = {
    // ABI fragments needed for encoding/verification.
    SAFE: [
        {
            inputs: [
                { internalType: "address[]", name: "owners", type: "address[]" },
                { internalType: "uint256", name: "threshold", type: "uint256" },
                { internalType: "address", name: "to", type: "address" },
                { internalType: "bytes", name: "data", type: "bytes" },
                { internalType: "address", name: "fallbackHandler", type: "address" },
                { internalType: "address", name: "paymentToken", type: "address" },
                { internalType: "uint256", name: "payment", type: "uint256" },
                { internalType: "address", name: "paymentReceiver", type: "address" },
            ],
            name: "setup",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function",
        },
        {
            inputs: [],
            name: "getOwners",
            outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
            stateMutability: "view",
            type: "function",
        },
        {
            inputs: [],
            name: "getThreshold",
            outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
            stateMutability: "view",
            type: "function",
        },
    ],
    SAFE_PROXY: [
        {
            anonymous: false,
            inputs: [
                {
                    indexed: false,
                    internalType: "contract GnosisSafeProxy",
                    name: "proxy",
                    type: "address",
                },
                {
                    indexed: false,
                    internalType: "address",
                    name: "singleton",
                    type: "address",
                },
            ],
            name: "ProxyCreation",
            type: "event",
        },
        {
            inputs: [
                { internalType: "address", name: "_singleton", type: "address" },
                { internalType: "bytes", name: "initializer", type: "bytes" },
                { internalType: "uint256", name: "saltNonce", type: "uint256" },
            ],
            name: "createProxyWithNonce",
            outputs: [
                {
                    internalType: "contract GnosisSafeProxy",
                    name: "proxy",
                    type: "address",
                },
            ],
            stateMutability: "nonpayable",
            type: "function",
        },
    ],
    // Some factory deployments index the proxy address; keep a minimal fallback
    // ABI to decode those receipts (proxy indexed, singleton not indexed).
    SAFE_PROXY_INDEXED: [
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: "contract GnosisSafeProxy",
                    name: "proxy",
                    type: "address",
                },
                {
                    indexed: false,
                    internalType: "address",
                    name: "singleton",
                    type: "address",
                },
            ],
            name: "ProxyCreation",
            type: "event",
        },
    ],
};
